@let announcement = item();
<div
  class="flex items-start gap-base pt-base px-base cursor-pointer rounded-base"
  [ngClass]="selected() ? 'bg-primary/15 dark:bg-primary/30' : 'hover:bg-ui-hover'"
  (click)="opened.emit()"
>
  <div class="shrink-0 w-sm pt-[6px]">
    @if (!announcement.readDate) {
      <span class="block w-sm h-sm rounded-full bg-primary"></span>
    }
  </div>
  <div
    class="flex-1 min-w-0 pb-base border-b"
    [ngClass]="selected() || nextItemSelected() ? 'border-transparent' : 'border-ui-separator'"
  >
    <div class="flex items-start gap-base">
      <div class="flex-1 min-w-0">
        <div class="text-base leading-base text-txt font-semibold">{{ announcement.title }}</div>
        <div class="mt-2xs text-sm leading-sm text-txt-disabled truncate">
          {{ announcement.senderName }} ·
          {{ announcement.sentDate | llaUtcToLocalDate | date: 'MMM d, y' }}
        </div>
      </div>
      @if (announcement.imageUrls?.length) {
        <svg-icon key="paperclip" class="shrink-0 text-base! text-txt-disabled"></svg-icon>
      }
    </div>
    <div class="mt-sm text-sm leading-sm text-txt line-clamp-2">
      {{ announcement.body | llaStripHtml }}
    </div>
  </div>
</div>
